// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Package card ─────────────────────────────────────────────────────────── */

.kK8a8PJStOaRVIu_gPdl {
    position: relative;
    display: grid;
    grid-template-columns: 72px 1fr auto;
    gap: 16px;
    align-items: center;
    padding: 14px;
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-lg);
    background: var(--curio-card-bg);
    box-shadow: var(--curio-shadow-card);
    font-family: var(--curio-font-family);
    transition: box-shadow 0.15s, border-color 0.15s;
}

.kK8a8PJStOaRVIu_gPdl:hover {
    border-color: var(--curio-border-strong);
}

/* Icon tile — keyed to the package's node category, the same palette the
   canvas paints a node's left border with. */

.Cy__qkJcxm1OIY3nTZP3 {
    width: 72px;
    height: 72px;
    border-radius: var(--curio-radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: var(--curio-page-bg);
}

.bdb6vpVkCazDlm2Ews1n {
    background: var(--curio-category-data-bg);
    color: var(--curio-category-data-on-tint);
}

.DGnj4woVwQUXYphl50O5 {
    background: var(--curio-category-computation-bg);
    color: var(--curio-category-computation-on-tint);
}

.AtscTk8dWiC6XWTH7aES {
    background: var(--curio-category-vis-bg);
    color: var(--curio-category-vis-on-tint);
}

.pEcCgNseUDa78TRygVrw {
    background: var(--curio-category-package-bg);
    color: var(--curio-category-package-on-tint);
}

.vnU4FAbQMfN5fEq_cXUQ {
    font-size: 1.375rem;
    font-weight: 700;
}

/* Body */

.ENurNdz_SO22pmM1o1t7 {
    min-width: 0;
}

.Sgh5UKgqFHxtTQp1uxxW {
    margin: 0 0 4px;
    font-size: var(--curio-font-size-lg);
    font-weight: 600;
    color: var(--curio-text-primary);
    overflow-wrap: anywhere;
}

.iC4UFZl_5SgY0fs2qUGm {
    margin: 0 0 8px;
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-muted);
}

.YuOkOWpLcj1uLedAFMMA {
    margin: 0;
    font-size: 11px;
    color: var(--curio-text-meta);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;
}

.vUCT2H6hiviXvbvQi52R {
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 600;
    color: var(--curio-text-meta);
    background: var(--curio-surface-alt);
    border-radius: 4px;
    padding: 0 4px;
    line-height: 16px;
    /* The tag row stretches its items to the taller tags beside it, which
       left the one 16 px line at the top of a taller chip (#495). */
    align-self: center;
}

.mzQN4W_TYp3LBOmIuH4r {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 16px;
    /* Matches .cardMeta, the package card's equivalent line. */
    margin: 0 0 8px;
}

.JLY64jSju0xBwF2en4Nn {
    width: 100%;
    font-size: 11px;
    color: var(--curio-text-meta);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* A meta line that wraps rather than cut off: a model card's weights license. */
.xZBegKzBFZGjeKQW93fi {
    white-space: normal;
}

.liicWabhGjWWwAVOyKvA {
    flex-shrink: 0;
    border-radius: 8px;
    background: var(--curio-surface-alt);
    color: var(--curio-text-secondary);
    padding: 2px 8px;
    font-size: 10px;
    font-weight: 600;
    line-height: 1.4;
    white-space: nowrap;
}
  
.zKVNg9lXONJr97vYiVJP {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.x6ky_lYdzlUxwsQST2RU {
    display: inline-block;
    padding: 2px 8px;
    border-radius: var(--curio-radius-sm);
    background: var(--curio-page-bg);
    font-size: var(--curio-font-size-xs);
    color: var(--curio-text-secondary);
}

.sRrrRiay2VucuU51ANFf {
    background: var(--curio-role-update-bg);
    color: var(--curio-role-update-fg);
    font-weight: 700;
}

.M5vqjx2a1KKzgQkYmqb2 {
    background: var(--curio-role-published-bg);
    color: var(--curio-role-published-fg);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

/* Action column */

.BzFFXZ9ZslFUXRkhHIoh {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    min-width: 96px;
}

.BN6uLvKQ2COZ__OU7tcn {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.hk6Z0lEWWuTnmx_gFvkb {
    min-width: 96px;
    height: var(--curio-input-height);
    padding: 0 16px;
    border: none;
    border-radius: var(--curio-radius-md);
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    font: inherit;
    font-size: var(--curio-font-size-lg);
    font-weight: 600;
    cursor: pointer;
}

.hk6Z0lEWWuTnmx_gFvkb:hover:not(:disabled) {
    background: var(--curio-top-bar-bg-hover);
}

.ydMisXTNkApY6sSZfpIR {
    background: var(--curio-role-update-fg);
    color: var(--curio-card-bg);
}

.ydMisXTNkApY6sSZfpIR:hover:not(:disabled) {
    background: #d05a30;
}

.hk6Z0lEWWuTnmx_gFvkb:disabled,
.ydMisXTNkApY6sSZfpIR:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.YB5UUtrpv3brzAZR4q1Z {
    min-width: 96px;
    height: 30px;
    padding: 0 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-sm);
    font-weight: 500;
    cursor: pointer;
}

.YB5UUtrpv3brzAZR4q1Z:hover:not(:disabled) {
    border-color: #888787;
    background: #f5f5f5;
}

.YB5UUtrpv3brzAZR4q1Z:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ── Draggable card  ─────────────────────────────────────────────────────────── */
.CMJi5g8vBICtfXL7qH69 {
  cursor: grab;
}

.CMJi5g8vBICtfXL7qH69:active {
  cursor: grabbing;
}

/* ── Format avatar ───────────────────────────────────────────────────────────── */

/* Same box as .cardIcon, which fills this slot on a package card. Only the
   button affordances below are specific to the dataset side. */
/* Column 1 of the card grid: the square, and the way into the item's details
 * directly beneath it. "View details" was previously wherever each card
 * happened to put it - in the action column on one, between two buttons on
 * another - so the same affordance moved around between catalogs. It lives in
 * one place now, under the square, on every drawer card. */
.l28WTCHOWYZjkWnEfFLS {
  width: 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

/* A link, not a button: it navigates rather than acting, so it takes neither
 * the dark action fill nor the light destructive one. */
.rXvvNlLuxXqirpuyiQR5 {
  border: 0;
  background: none;
  padding: 0;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--curio-text-primary);
  cursor: pointer;
  white-space: nowrap;
}

.rXvvNlLuxXqirpuyiQR5:hover {
  text-decoration: underline;
}

.tf5TTnymZ_9u48G9Zdm4 {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  align-self: center;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--curio-radius-md);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.3px;
  line-height: 1.2;
  text-align: center;
  text-transform: uppercase;
  word-break: break-all;
  /* Fallback for a format with no tint of its own. */
  background: var(--curio-surface-alt);
  color: var(--curio-text-secondary);
}

.WLWUsOSeZqGvykalTZRU {
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
}

.WLWUsOSeZqGvykalTZRU:hover {
  box-shadow: 0 0 0 2px var(--curio-top-bar-bg);
}

/* A card with no details handler still renders the square, just inert. These
 * come AFTER the :hover rule above - equal specificity, so source order is what
 * decides, and written first they lost to it. */
.WLWUsOSeZqGvykalTZRU:disabled {
  cursor: default;
}

.WLWUsOSeZqGvykalTZRU:disabled:hover {
  box-shadow: none;
}

/* Format-specific avatar colours (light surface) */
.oOGn8TBPBGOa1sPKtFd0 { background: var(--curio-format-geojson-bg) !important; color: var(--curio-format-geojson-on-tint); }
.TSeaiqfKRXLDkZurN4SA { background: var(--curio-format-csv-bg) !important; color: var(--curio-format-csv-on-tint); }
.hFziGxAzytKhYwWXTdH1 { background: var(--curio-format-json-bg) !important; color: var(--curio-format-json-on-tint); }
.dLbhHyCBju0uS___AjBv { background: var(--curio-format-parquet-bg) !important; color: var(--curio-format-parquet-on-tint); }
.nYRxzw6DS7MB3rUn7MUX { background: var(--curio-format-geotiff-bg) !important; color: var(--curio-format-geotiff-on-tint); }
.FfcbgRzFuAZwDZusHiBQ { background: var(--curio-format-shp-bg) !important; color: var(--curio-format-shp-on-tint); }
.oFvbQTrW9V9MMuKH0vzE { background: var(--curio-format-bundle-bg) !important; color: var(--curio-format-bundle-on-tint); }
.pV6nl5LXhSIrHLHZBYtV { background: var(--curio-format-osm-bg) !important; color: var(--curio-format-osm-on-tint); }
.mFjODz1AYUwZ85QsOwNw { background: var(--curio-format-gpkg-bg) !important; color: var(--curio-format-gpkg-on-tint); }
.xR8Ec8JNzQWvVbsZgzfY { background: var(--curio-format-gtfs-bg) !important; color: var(--curio-format-gtfs-on-tint); }
.UALpmk9zwFZkM2pgKXPQ { background: var(--curio-format-collection-bg) !important; color: var(--curio-format-collection-on-tint); }
.blMBm9C9569VYC0dg12w { background: var(--curio-format-onnx-bg) !important; color: var(--curio-format-onnx-on-tint); }
.DLBvGCDBAx1o4in8nL1J { background: var(--curio-format-netcdf-bg) !important; color: var(--curio-format-netcdf-on-tint); }

/* A Model Catalog card's avatar: a kind, not a format, so it takes the one
   model colour (see --curio-kind-model-fg). */
.m5VVtUx4bCEPJnOaezkH { background: var(--curio-kind-model-bg) !important; color: var(--curio-kind-model-on-tint); }

`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/PackageCard.module.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;IACI,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,qCAAqC;IACrC,gCAAgC;IAChC,oCAAoC;IACpC,qCAAqC;IACrC,gDAAgD;AACpD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;6CAC6C;;AAE7C;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,yCAAyC;IACzC,yCAAyC;AAC7C;;AAEA;IACI,gDAAgD;IAChD,gDAAgD;AACpD;;AAEA;IACI,wCAAwC;IACxC,wCAAwC;AAC5C;;AAEA;IACI,4CAA4C;IAC5C,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,SAAS;;AAET;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,oCAAoC;IACpC,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB;oEACgE;IAChE,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;IAChB,2DAA2D;IAC3D,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,gFAAgF;AAChF;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,qCAAqC;IACrC,gCAAgC;IAChC,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;IACrC,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,kBAAkB;;AAElB;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,mFAAmF;AACnF;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mFAAmF;;AAEnF;+DAC+D;AAC/D;;;;2DAI2D;AAC3D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;wDACwD;AACxD;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,mDAAmD;EACnD,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;gDAEgD;AAChD;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD,wBAAkB,qDAAqD,EAAE,0CAA0C,EAAE;AACrH,wBAAc,iDAAiD,EAAE,sCAAsC,EAAE;AACzG,wBAAe,kDAAkD,EAAE,uCAAuC,EAAE;AAC5G,wBAAkB,qDAAqD,EAAE,0CAA0C,EAAE;AACrH,wBAAkB,qDAAqD,EAAE,0CAA0C,EAAE;AACrH,wBAAc,iDAAiD,EAAE,sCAAsC,EAAE;AACzG,wBAAiB,oDAAoD,EAAE,yCAAyC,EAAE;AAClH,wBAAc,iDAAiD,EAAE,sCAAsC,EAAE;AACzG,wBAAe,kDAAkD,EAAE,uCAAuC,EAAE;AAC5G,wBAAe,kDAAkD,EAAE,uCAAuC,EAAE;AAC5G,wBAAqB,wDAAwD,EAAE,6CAA6C,EAAE;AAC9H,wBAAe,kDAAkD,EAAE,uCAAuC,EAAE;AAC5G,wBAAiB,oDAAoD,EAAE,yCAAyC,EAAE;;AAElH;8CAC8C;AAC9C,wBAAgB,iDAAiD,EAAE,sCAAsC,EAAE","sourcesContent":["/* ── Package card ─────────────────────────────────────────────────────────── */\n\n.card {\n    position: relative;\n    display: grid;\n    grid-template-columns: 72px 1fr auto;\n    gap: 16px;\n    align-items: center;\n    padding: 14px;\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-lg);\n    background: var(--curio-card-bg);\n    box-shadow: var(--curio-shadow-card);\n    font-family: var(--curio-font-family);\n    transition: box-shadow 0.15s, border-color 0.15s;\n}\n\n.card:hover {\n    border-color: var(--curio-border-strong);\n}\n\n/* Icon tile — keyed to the package's node category, the same palette the\n   canvas paints a node's left border with. */\n\n.cardIcon {\n    width: 72px;\n    height: 72px;\n    border-radius: var(--curio-radius-md);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background: var(--curio-page-bg);\n}\n\n.cardIcon_data {\n    background: var(--curio-category-data-bg);\n    color: var(--curio-category-data-on-tint);\n}\n\n.cardIcon_computation {\n    background: var(--curio-category-computation-bg);\n    color: var(--curio-category-computation-on-tint);\n}\n\n.cardIcon_vis {\n    background: var(--curio-category-vis-bg);\n    color: var(--curio-category-vis-on-tint);\n}\n\n.cardIcon_package {\n    background: var(--curio-category-package-bg);\n    color: var(--curio-category-package-on-tint);\n}\n\n.cardIconText {\n    font-size: 1.375rem;\n    font-weight: 700;\n}\n\n/* Body */\n\n.cardBody {\n    min-width: 0;\n}\n\n.cardTitle {\n    margin: 0 0 4px;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 600;\n    color: var(--curio-text-primary);\n    overflow-wrap: anywhere;\n}\n\n.cardMeta {\n    margin: 0 0 8px;\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-muted);\n}\n\n.cardSource {\n    margin: 0;\n    font-size: 11px;\n    color: var(--curio-text-meta);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.versionBadge {\n    flex-shrink: 0;\n    font-size: 10px;\n    font-weight: 600;\n    color: var(--curio-text-meta);\n    background: var(--curio-surface-alt);\n    border-radius: 4px;\n    padding: 0 4px;\n    line-height: 16px;\n    /* The tag row stretches its items to the taller tags beside it, which\n       left the one 16 px line at the top of a taller chip (#495). */\n    align-self: center;\n}\n\n.cardMetaRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    min-height: 16px;\n    /* Matches .cardMeta, the package card's equivalent line. */\n    margin: 0 0 8px;\n}\n\n.cardMetaText {\n    width: 100%;\n    font-size: 11px;\n    color: var(--curio-text-meta);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* A meta line that wraps rather than cut off: a model card's weights license. */\n.cardMetaWrap {\n    white-space: normal;\n}\n\n.connBadge {\n    flex-shrink: 0;\n    border-radius: 8px;\n    background: var(--curio-surface-alt);\n    color: var(--curio-text-secondary);\n    padding: 2px 8px;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 1.4;\n    white-space: nowrap;\n}\n  \n.tagRow {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.tag {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: var(--curio-radius-sm);\n    background: var(--curio-page-bg);\n    font-size: var(--curio-font-size-xs);\n    color: var(--curio-text-secondary);\n}\n\n.tagUpdate {\n    background: var(--curio-role-update-bg);\n    color: var(--curio-role-update-fg);\n    font-weight: 700;\n}\n\n.tagChannel {\n    background: var(--curio-role-published-bg);\n    color: var(--curio-role-published-fg);\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n/* Action column */\n\n.cardAction {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 6px;\n    min-width: 96px;\n}\n\n.cardSecondaryActions {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.btnInstall {\n    min-width: 96px;\n    height: var(--curio-input-height);\n    padding: 0 16px;\n    border: none;\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.btnInstall:hover:not(:disabled) {\n    background: var(--curio-top-bar-bg-hover);\n}\n\n.btnInstallAccent {\n    background: var(--curio-role-update-fg);\n    color: var(--curio-card-bg);\n}\n\n.btnInstallAccent:hover:not(:disabled) {\n    background: #d05a30;\n}\n\n.btnInstall:disabled,\n.btnInstallAccent:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.btnSecondary {\n    min-width: 96px;\n    height: 30px;\n    padding: 0 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-sm);\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.btnSecondary:hover:not(:disabled) {\n    border-color: #888787;\n    background: #f5f5f5;\n}\n\n.btnSecondary:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* ── Draggable card  ─────────────────────────────────────────────────────────── */\n.cardDraggable {\n  cursor: grab;\n}\n\n.cardDraggable:active {\n  cursor: grabbing;\n}\n\n/* ── Format avatar ───────────────────────────────────────────────────────────── */\n\n/* Same box as .cardIcon, which fills this slot on a package card. Only the\n   button affordances below are specific to the dataset side. */\n/* Column 1 of the card grid: the square, and the way into the item's details\n * directly beneath it. \"View details\" was previously wherever each card\n * happened to put it - in the action column on one, between two buttons on\n * another - so the same affordance moved around between catalogs. It lives in\n * one place now, under the square, on every drawer card. */\n.cardAvatarCol {\n  width: 72px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n/* A link, not a button: it navigates rather than acting, so it takes neither\n * the dark action fill nor the light destructive one. */\n.avatarDetailsLink {\n  border: 0;\n  background: none;\n  padding: 0;\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--curio-text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.avatarDetailsLink:hover {\n  text-decoration: underline;\n}\n\n.cardAvatar {\n  flex-shrink: 0;\n  width: 72px;\n  height: 72px;\n  align-self: center;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--curio-radius-md);\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.3px;\n  line-height: 1.2;\n  text-align: center;\n  text-transform: uppercase;\n  word-break: break-all;\n  /* Fallback for a format with no tint of its own. */\n  background: var(--curio-surface-alt);\n  color: var(--curio-text-secondary);\n}\n\n.cardAvatarButton {\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n}\n\n.cardAvatarButton:hover {\n  box-shadow: 0 0 0 2px var(--curio-top-bar-bg);\n}\n\n/* A card with no details handler still renders the square, just inert. These\n * come AFTER the :hover rule above - equal specificity, so source order is what\n * decides, and written first they lost to it. */\n.cardAvatarButton:disabled {\n  cursor: default;\n}\n\n.cardAvatarButton:disabled:hover {\n  box-shadow: none;\n}\n\n/* Format-specific avatar colours (light surface) */\n.avatar_geojson { background: var(--curio-format-geojson-bg) !important; color: var(--curio-format-geojson-on-tint); }\n.avatar_csv { background: var(--curio-format-csv-bg) !important; color: var(--curio-format-csv-on-tint); }\n.avatar_json { background: var(--curio-format-json-bg) !important; color: var(--curio-format-json-on-tint); }\n.avatar_parquet { background: var(--curio-format-parquet-bg) !important; color: var(--curio-format-parquet-on-tint); }\n.avatar_geotiff { background: var(--curio-format-geotiff-bg) !important; color: var(--curio-format-geotiff-on-tint); }\n.avatar_shp { background: var(--curio-format-shp-bg) !important; color: var(--curio-format-shp-on-tint); }\n.avatar_bundle { background: var(--curio-format-bundle-bg) !important; color: var(--curio-format-bundle-on-tint); }\n.avatar_osm { background: var(--curio-format-osm-bg) !important; color: var(--curio-format-osm-on-tint); }\n.avatar_gpkg { background: var(--curio-format-gpkg-bg) !important; color: var(--curio-format-gpkg-on-tint); }\n.avatar_gtfs { background: var(--curio-format-gtfs-bg) !important; color: var(--curio-format-gtfs-on-tint); }\n.avatar_collection { background: var(--curio-format-collection-bg) !important; color: var(--curio-format-collection-on-tint); }\n.avatar_onnx { background: var(--curio-format-onnx-bg) !important; color: var(--curio-format-onnx-on-tint); }\n.avatar_netcdf { background: var(--curio-format-netcdf-bg) !important; color: var(--curio-format-netcdf-on-tint); }\n\n/* A Model Catalog card's avatar: a kind, not a format, so it takes the one\n   model colour (see --curio-kind-model-fg). */\n.avatar_model { background: var(--curio-kind-model-bg) !important; color: var(--curio-kind-model-on-tint); }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `kK8a8PJStOaRVIu_gPdl`,
	"cardIcon": `Cy__qkJcxm1OIY3nTZP3`,
	"cardIcon_data": `bdb6vpVkCazDlm2Ews1n`,
	"cardIcon_computation": `DGnj4woVwQUXYphl50O5`,
	"cardIcon_vis": `AtscTk8dWiC6XWTH7aES`,
	"cardIcon_package": `pEcCgNseUDa78TRygVrw`,
	"cardIconText": `vnU4FAbQMfN5fEq_cXUQ`,
	"cardBody": `ENurNdz_SO22pmM1o1t7`,
	"cardTitle": `Sgh5UKgqFHxtTQp1uxxW`,
	"cardMeta": `iC4UFZl_5SgY0fs2qUGm`,
	"cardSource": `YuOkOWpLcj1uLedAFMMA`,
	"versionBadge": `vUCT2H6hiviXvbvQi52R`,
	"cardMetaRow": `mzQN4W_TYp3LBOmIuH4r`,
	"cardMetaText": `JLY64jSju0xBwF2en4Nn`,
	"cardMetaWrap": `xZBegKzBFZGjeKQW93fi`,
	"connBadge": `liicWabhGjWWwAVOyKvA`,
	"tagRow": `zKVNg9lXONJr97vYiVJP`,
	"tag": `x6ky_lYdzlUxwsQST2RU`,
	"tagUpdate": `sRrrRiay2VucuU51ANFf`,
	"tagChannel": `M5vqjx2a1KKzgQkYmqb2`,
	"cardAction": `BzFFXZ9ZslFUXRkhHIoh`,
	"cardSecondaryActions": `BN6uLvKQ2COZ__OU7tcn`,
	"btnInstall": `hk6Z0lEWWuTnmx_gFvkb`,
	"btnInstallAccent": `ydMisXTNkApY6sSZfpIR`,
	"btnSecondary": `YB5UUtrpv3brzAZR4q1Z`,
	"cardDraggable": `CMJi5g8vBICtfXL7qH69`,
	"cardAvatarCol": `l28WTCHOWYZjkWnEfFLS`,
	"avatarDetailsLink": `rXvvNlLuxXqirpuyiQR5`,
	"cardAvatar": `tf5TTnymZ_9u48G9Zdm4`,
	"cardAvatarButton": `WLWUsOSeZqGvykalTZRU`,
	"avatar_geojson": `oOGn8TBPBGOa1sPKtFd0`,
	"avatar_csv": `TSeaiqfKRXLDkZurN4SA`,
	"avatar_json": `hFziGxAzytKhYwWXTdH1`,
	"avatar_parquet": `dLbhHyCBju0uS___AjBv`,
	"avatar_geotiff": `nYRxzw6DS7MB3rUn7MUX`,
	"avatar_shp": `FfcbgRzFuAZwDZusHiBQ`,
	"avatar_bundle": `oFvbQTrW9V9MMuKH0vzE`,
	"avatar_osm": `pV6nl5LXhSIrHLHZBYtV`,
	"avatar_gpkg": `mFjODz1AYUwZ85QsOwNw`,
	"avatar_gtfs": `xR8Ec8JNzQWvVbsZgzfY`,
	"avatar_collection": `UALpmk9zwFZkM2pgKXPQ`,
	"avatar_onnx": `blMBm9C9569VYC0dg12w`,
	"avatar_netcdf": `DLBvGCDBAx1o4in8nL1J`,
	"avatar_model": `m5VVtUx4bCEPJnOaezkH`
};
export default ___CSS_LOADER_EXPORT___;
